// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lkfr-app.lkfr-app--assistant .lkfr-content {
  padding: 24px;
}

.assistant-chat-page {
  height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height, 75px) - 48px);
  max-width: 1120px;
  width: 100%;
  min-height: 0;
  margin: 0 auto;
  border: 1px solid var(--lkfr-border, #e4e8ee);
  border-radius: 20px;
  overflow: hidden;
  background: white;
}

.assistant-page-state {
  display: grid;
  place-content: center;
  height: 100%;
  padding: 24px;
  text-align: center;
}
.assistant-page-state h1 {
  font-size: 23px;
}
.assistant-page-state p {
  color: var(--lkfr-muted);
}

@media (max-width: 1099px) {
  .lkfr-app.lkfr-app--assistant .lkfr-content {
    padding: 0;
  }
  .assistant-chat-page {
    height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height, 66px));
    border: 0;
    border-radius: 0;
  }
}
body.ticket-native-document .lkfr-app--assistant .assistant-chat-page {
  position: fixed;
  top: var(--lkfr-header-height, 66px);
  left: 0;
  right: 0;
  width: 100%;
}

@media (min-width: 1100px) {
  body.ticket-native-document .lkfr-app--assistant .assistant-chat-page {
    left: calc(var(--lkfr-sidebar-width) + 24px);
    width: calc(100% - var(--lkfr-sidebar-width) - 48px);
    top: calc(var(--lkfr-header-height) + 24px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AssistantPage/AssistantPage.scss"],"names":[],"mappings":"AAAA;EAA8C,aAAA;AAE9C;;AADA;EACE,8HAAA;EACA,iBAAA;EAAmB,WAAA;EAAa,aAAA;EAAe,cAAA;EAC/C,6CAAA;EAA+C,mBAAA;EAC/C,gBAAA;EAAkB,iBAAA;AASpB;;AAPA;EAAwB,aAAA;EAAe,qBAAA;EAAuB,YAAA;EAAc,aAAA;EAAe,kBAAA;AAe3F;AAf+G;EAAK,eAAA;AAkBpH;AAlBuI;EAAI,wBAAA;AAqB3I;;AApBA;EACE;IAA8C,UAAA;EAwB9C;EAvBA;IAAuB,uHAAA;IAAyH,SAAA;IAAW,gBAAA;EA4B3J;AACF;AA3BA;EAAwE,eAAA;EAAiB,oCAAA;EAAsC,OAAA;EAAS,QAAA;EAAU,WAAA;AAkClJ;;AAjCA;EACE;IAAwE,4CAAA;IAA8C,oDAAA;IAAsD,2CAAA;EAuC5K;AACF","sourcesContent":[".lkfr-app.lkfr-app--assistant .lkfr-content { padding: 24px; }\n.assistant-chat-page {\n  height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height, 75px) - 48px);\n  max-width: 1120px; width: 100%; min-height: 0; margin: 0 auto;\n  border: 1px solid var(--lkfr-border, #e4e8ee); border-radius: 20px;\n  overflow: hidden; background: white;\n}\n.assistant-page-state { display: grid; place-content: center; height: 100%; padding: 24px; text-align: center; h1 { font-size: 23px; } p { color: var(--lkfr-muted); } }\n@media (max-width: 1099px) {\n  .lkfr-app.lkfr-app--assistant .lkfr-content { padding: 0; }\n  .assistant-chat-page { height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height, 66px)); border: 0; border-radius: 0; }\n}\nbody.ticket-native-document .lkfr-app--assistant .assistant-chat-page { position: fixed; top: var(--lkfr-header-height, 66px); left: 0; right: 0; width: 100%; }\n@media (min-width: 1100px) {\n  body.ticket-native-document .lkfr-app--assistant .assistant-chat-page { left: calc(var(--lkfr-sidebar-width) + 24px); width: calc(100% - var(--lkfr-sidebar-width) - 48px); top: calc(var(--lkfr-header-height) + 24px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
